<template>
  <div class="mx-3 py-2">
    <fdw-odds-comparison client="114" league="nba"></fdw-odds-comparison>
  </div>
</template>

<script>
export default {
  name: "NbaSportsBook",
};
</script>

<style lang="scss" scoped></style>
